/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { DsmButton, DsmGrid, DsmIcon } from '@dsm-dcs/design-system-react';
import { FC, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { capitalize, sortedUniqBy } from 'lodash';
import { useIntl } from '../../../../../../_metronic/i18n/customUseIntl';
import { processAndStageStylesV2 } from '../../../../../../_metronic/layout';
import {
  DatabaseFoundation,
  InputAnimalOrigin,
} from '../../../../../../graphql/generated/blonk/pigs';
import {
  CSSClassesList,
  ReactChangedType,
} from '../../../../helpers/helperTypes';
import { FormType, ListEntry, DairyV2Farms } from '../../common';
import { UserProfilePrefs } from '../../../../../modules/Helpers/UserProfilePrefs';
import { unitLong } from '../../../../utils/unit-utils';
import ReactHookDsmInput from '../../../../../modules/Helpers/ReactHookDsmInput2';
import ReactHookDsmSelect from '../../../../../modules/Helpers/ReactHookDsmSelect2';
import {
  DairyV2Baseline,
  DairyV2Stage,
} from '../../../../models/Baseline/DairyV2Baseline';
import { InternalSource } from '../../../../models/Baseline/CattleBaseline';
import { ReportingType, StageType } from '../../../../../../graphql/types';
import { AnimalType } from '../../../../../../graphql/generated/blonk/cattle';
import ReactHookDsmRadioGroup from '../../../../../modules/Helpers/ReactHookDsmRadioGroup';
import { Tooltip } from '@material-ui/core';
import _ from 'lodash';
import { filterDatabaseOption } from '../../../../helpers/initialValues';

interface DairyV2InputPartInternalSourceProps {
  farms: DairyV2Farms[];
  farmId: string;
  farmName: string;
  allowedStagesForFarm: string[];
  productionProcessName: string;
  stageIndex: number;
  // eslint-disable-next-line react/require-default-props
  itemIndex: number;
  formType: FormType;
  stageType: StageType;
  fieldPrefix: string;
  // eslint-disable-next-line react/require-default-props
  removeHandler: (index: number) => void;
  // eslint-disable-next-line react/require-default-props
  triggerSelectionError?: boolean;
  updateSourceAnimalType?: (
    indexSource: number,
    stageTypeSource: StageType,
    animalTypeOptionSource: string
  ) => void;
  removeSourceAnimalType?: (indexSource: number) => void;
  shouldLockAnimalTypeSelection?: (index: number) => boolean;
  getAnimalTypeSelection?: () => string | undefined;
}

const DairyV2InputPartInternalSource: FC<DairyV2InputPartInternalSourceProps> = ({
  farms,
  farmId,
  farmName,
  allowedStagesForFarm,
  productionProcessName,
  stageIndex,
  itemIndex,
  fieldPrefix,
  stageType,
  formType,
  removeHandler,
  triggerSelectionError = false,
  updateSourceAnimalType = () => { },
  removeSourceAnimalType = () => { },
  shouldLockAnimalTypeSelection = () => false,
  getAnimalTypeSelection = () => '',
}) => {
  const intl = useIntl();
  const classes = processAndStageStylesV2() as CSSClassesList;
  const formContext = useFormContext<DairyV2Baseline>();
  const userProfile = UserProfilePrefs.getInstance();
  const userUOM = userProfile.getUserUnitPrefs();
  const distanceUnit = unitLong(
    userUOM.unitTransportDistanceTerrestrial as string
  );
  const calculateInitialDatabaseValue = () => {
    let initValue: DatabaseFoundation = formContext.getValues(
      `info.databaseFoundation`
    );
    let reportingType: ReportingType =
      formContext.getValues(`info.reportingType`);
    if (!initValue) {
      const userPreference = userProfile.getUserDatabasePrefs().databaseType;
      return filterDatabaseOption(
        userPreference,
        reportingType
      ) as DatabaseFoundation;
    }
    return filterDatabaseOption(initValue, reportingType) as DatabaseFoundation;
  };
  const fieldItemPrefix = `${fieldPrefix}.internalSources.${itemIndex}`;
  let selectedFarmId = '';
  useWatch({ name: `${fieldItemPrefix}` });

  const invalidateStageSelection = (e: ReactChangedType) => {
    formContext.setValue(`${fieldItemPrefix}.farmName`, e.target.name);
    const newSelection: string = e.target.value as string;
    if (newSelection !== selectedFarmId) {
      formContext.setValue(`${fieldItemPrefix}.originStageId`, '');
      formContext.setValue(`${fieldItemPrefix}.averageWeight`, '');
      selectedFarmId = newSelection;
      removeSourceAnimalType(itemIndex);
    }
  };

  const addCurrentFarm = (resultFarms: ListEntry[]) => {
    const currentStage: DairyV2Stage = formContext.getValues(
      `stages.${stageIndex}`
    );
    const currentFarm = resultFarms.find((farm) => farm.value === farmId);
    const stages = formContext
      .getValues('stages')
      .filter((stage: DairyV2Stage) =>
        allowedStagesForFarm.includes(stage.type ?? '')
      )
      .filter((stage: DairyV2Stage) => currentStage?.id !== stage.id);
    // If there are more then one stage on current opened baseline only then add the current farm and db
    if (stages?.length > 0 && currentFarm === undefined)
      resultFarms.push({ text: farmName, value: farmId });
  };

  const farmOptions = () => {
    // Filter out the Farm that are not relevant
    const resultFarms = farms
      .filter(
        (farm) =>
          farm.databaseFoundation === calculateInitialDatabaseValue() ||
          !farm.databaseFoundation
      )
      .filter((farm) => allowedStagesForFarm.includes(farm.stageType))
      .filter((farm) => !farm.benchmark)
      .map((farm) => ({ text: farm.farmName, value: farm.farmId }));
    // Add farm for currently opened stages
    addCurrentFarm(resultFarms);
    // Because a farm can have multiple processes and baselines, its entry can be duplicated
    return sortedUniqBy(resultFarms, 'value');
  };

  const generateSelectedIds = (): string[] => {
    const sources: InternalSource[] = formContext.getValues(
      `stages.${stageIndex}.stageData.input.internalSources`
    );
    return sources?.map(
      (internalSources: InternalSource) => internalSources.originStageId
    );
  };

  const formatStageType = (stageType: StageType): string => {
    return capitalize(stageType.toLowerCase().replace('_', ' '));
  };

  const formatAnimalType = (animalType: AnimalType): string => {
    return capitalize(animalType.toLowerCase().replace('_v2', ' '));
  };

  const stageOptions = () => {
    const currentlySelectedFarm: string =
      formContext.getValues(`${fieldItemPrefix}.farmId`) || farmId;
    const currentlySelectedStage: string = formContext.getValues(
      `${fieldItemPrefix}.originStageId`
    );
    const selectedStageIds = generateSelectedIds();
    const currentStage: DairyV2Stage = formContext.getValues(
      `stages.${stageIndex}`
    );
    const currentBaselineValues = formContext
      .getValues('stages')
      .map((stage) => ({
        databaseFoundation: calculateInitialDatabaseValue(),
        stageId: stage.id,
        stageType: stage.type,
        stageName: stage.name,
        farmId,
        productionProcessName,
        animalType: 'DAIRY_V2',
      }));
    return [...farms, ...currentBaselineValues]
      .filter(
        (farm) =>
          farm.databaseFoundation === calculateInitialDatabaseValue() ||
          !farm.databaseFoundation
      )
      .filter(
        (farm) =>
          !selectedStageIds.includes(farm.stageId) ||
          currentlySelectedStage === farm.stageId
      )
      .filter((farm) => allowedStagesForFarm.includes(String(farm.stageType)))
      .filter((farm) => farm.farmId === currentlySelectedFarm)
      .filter((farm) => farm.stageId !== currentStage?.id)
      .map((farm) => ({
        text: `${formatAnimalType(farm.animalType as AnimalType)} - ${farm.stageName} (${formatStageType(farm.stageType as StageType)})`,
        value: farm.stageId,
      }));
  };

  const [selectedStageType, setSelectedStageType] = useState<StageType>(
    formContext.getValues(`${fieldItemPrefix}.stageType`)
  );

  const stageSelection = async (e: ReactChangedType) => {
    const selectedStageId: string = e.target.value as string;
    const farm: DairyV2Farms | undefined = farms.find(
      (f: DairyV2Farms) => f.stageId === selectedStageId
    );
    if (farm) {
      // Stage selected from other farm
      formContext.setValue(`${fieldItemPrefix}.farmName`, farm.farmName);
      formContext.setValue(`${fieldItemPrefix}.stageName`, farm.stageName);
      formContext.setValue(`${fieldItemPrefix}.stageType`, farm.stageType);
      formContext.setValue(`${fieldItemPrefix}.baselineRef`, farm.reference);
      if (farm.stageType === StageType.ContinuousGrowing) {
        formContext.setValue(`${fieldItemPrefix}.animalType`, '');
      }
      updateSourceAnimalType(
        itemIndex,
        formContext.getValues(`${fieldItemPrefix}.stageType`),
        formContext.getValues(`${fieldItemPrefix}.animalType`)
      );
      setSelectedStageType(farm.stageType as StageType);
    } else {
      // Stage selected from this farm
      const currentStage: DairyV2Stage = formContext.getValues(
        `stages.${stageIndex}`
      );
      const foundStage = formContext
        .getValues('stages')
        .filter((stage) => allowedStagesForFarm.includes(String(stage.type)))
        .filter((stage) => currentStage?.id !== stage.id)
        .find((stage) => selectedStageId === stage.id);
      if (foundStage) {
        formContext.setValue(`${fieldItemPrefix}.farmName`, farmName);
        formContext.setValue(`${fieldItemPrefix}.stageName`, foundStage.name);
        formContext.setValue(`${fieldItemPrefix}.stageType`, foundStage.type);
        formContext.setValue(`${fieldItemPrefix}.baselineRef`, '');
        if (foundStage.type === StageType.ContinuousGrowing) {
          formContext.setValue(`${fieldItemPrefix}.animalType`, '');
        }
        updateSourceAnimalType(
          itemIndex,
          formContext.getValues(`${fieldItemPrefix}.stageType`),
          formContext.getValues(`${fieldItemPrefix}.animalType`)
        );
        setSelectedStageType(foundStage.type as StageType);
      }
    }
    await formContext.trigger(`${fieldItemPrefix}.originStageId`);
  };

  const defaultFarm = (): string => {
    const options = farmOptions();
    const farm: string =
      formContext.getValues(`${fieldItemPrefix}.farmId`) || farmId;
    const farmExists = options?.filter(
      (option: { value: string }) => option.value === farm
    )?.length;
    return farmExists ? farm : '';
  };

  const defaultStage = (): string => {
    const options = stageOptions();
    const stageId: string = formContext.getValues(
      `${fieldItemPrefix}.originStageId`
    );
    const stageExists = options?.filter(
      (option) => option.value === stageId
    )?.length;
    return stageExists ? stageId : '';
  };

  const animalTypeOptions = () =>
    Object.entries(AnimalType).map(([label, value]) => ({
      label,
      value,
    }));

  const updateRadioSelection = (value: string) => {
    updateSourceAnimalType(itemIndex, selectedStageType, value);
    formContext.trigger(`${fieldItemPrefix}.animalType`);
  };

  const getAnimalTypeValue = (): string | undefined =>
    formType !== FormType.View && shouldLockAnimalTypeSelection(itemIndex)
      ? getAnimalTypeSelection()
      : formContext.getValues(`${fieldItemPrefix}.animalType`);

  return (
    <>
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.origin`}
        value={InputAnimalOrigin.ProductionSystem}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.id`}
        value={formContext.getValues(`${fieldItemPrefix}.id`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.stageType`}
        value={formContext.getValues(`${fieldItemPrefix}.stageType`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.farmName`}
        value={formContext.getValues(`${fieldItemPrefix}.farmName`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.stageName`}
        value={formContext.getValues(`${fieldItemPrefix}.stageName`)}
      />
      <input
        ref={formContext.register()}
        type="hidden"
        name={`${fieldItemPrefix}.baselineRef`}
        value={formContext.getValues(`${fieldItemPrefix}.baselineRef`)}
      />
      <DsmGrid className={classes.additionalEntriesBlockHolder}>
        {formType !== FormType.View && (
          <DsmButton
            variant="text"
            style={{ position: 'relative', width: '100%' }}
            onClick={() => {
              removeHandler(itemIndex);
              removeSourceAnimalType(itemIndex);
            }}
          >
            <DsmIcon
              name="general/x-close"
              style={{
                position: 'absolute',
                color: 'var(--dsm-color-neutral-darker',
                right: '0',
              }}
            />
          </DsmButton>
        )}
        <div style={{ marginBottom: 'var(--dsm-spacing-px-4)' }}>
          <ReactHookDsmSelect
            style={{ width: '100%' }}
            name={`${fieldItemPrefix}.farmId`}
            label={intl.formatMessage({
              id: 'SUSTELL.STAGE.DAIRY.INPUT.FARM',
            })}
            disabled={formType === FormType.View}
            adornment={intl.formatMessage({
              id: 'SUSTELL.STAGE.DAIRY.INPUT.FARM.ADORNMENT',
            })}
            tooltip={intl.formatMessage({
              id: stageType === StageType.ContinuousGrowing
                ? 'SUSTELL.STAGE.DAIRY.INPUT.FARM.CONTINUOUS_GROWING.TOOLTIP'
                : 'SUSTELL.STAGE.DAIRY.INPUT.FARM.TOOLTIP',
            })}
            options={farmOptions()}
            changeHandler={invalidateStageSelection}
            required
            defaultValue={defaultFarm()}
          />
        </div>
        <div style={{ marginBottom: 'var(--dsm-spacing-px-4)' }}>
          <ReactHookDsmSelect
            style={{ width: '100%' }}
            name={`${fieldItemPrefix}.originStageId`}
            label={intl.formatMessage({
              id: `SUSTELL.STAGE.DAIRY.INPUT.STAGE`,
            })}
            disabled={formType === FormType.View}
            adornment={intl.formatMessage({
              id: `SUSTELL.STAGE.DAIRY.INPUT.STAGE.ADORNMENT`,
            })}
            tooltip={intl.formatMessage({
              id: 'SUSTELL.STAGE.DAIRY.INPUT.STAGE.TOOLTIP',
            })}
            options={stageOptions()}
            changeHandler={async (e: ReactChangedType) => {
              await stageSelection(e);
              if (triggerSelectionError)
                await formContext.trigger(
                  `stages.${stageIndex}.stageData.input.selection`
                );
            }}
            required
            defaultValue={defaultStage()}
          />
        </div>
        {stageType === StageType.ContinuousGrowing &&
          selectedStageType === StageType.DairyCow && (
            <DsmGrid className={classes.dsmGridSmallerColumnNoRowSpacing}>
              <ReactHookDsmRadioGroup
                name={`${fieldItemPrefix}.animalType`}
                label={`${intl.formatMessage({
                  id: 'SUSTELL.STAGE.BEEF.INPUT.ANIMAL_TYPE',
                })}`}
                options={animalTypeOptions()}
                disabled={
                  formType === FormType.View ||
                  shouldLockAnimalTypeSelection(itemIndex)
                }
                defaultValue={getAnimalTypeValue()}
                required
                changeHandler={updateRadioSelection}
              />
              <Tooltip
                title={intl.formatMessage({
                  id: 'SUSTELL.STAGE.DAIRY.INPUT.ANIMAL_TYPE.TOOLTIP',
                })}
                placement="left"
              >
                <DsmIcon
                  name="general/help-circle"
                  className={classes.inlineTooltipClass}
                  title=""
                />
              </Tooltip>
            </DsmGrid>
          )}
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.numberAnimals`}
          label={intl.formatMessage({
            id: `SUSTELL.STAGE.DAIRY.INPUT.ANIMALS_ENTERING_STAGE`,
          })}
          adornment={intl.formatMessage({
            id: `SUSTELL.STAGE.DAIRY.INPUT.ANIMALS_ENTERING_STAGE.ADORNMENT`,
          })}
          disabled={formType === FormType.View}
          tooltip={intl.formatMessage({
            id: stageType === StageType.ContinuousGrowing
              ? `SUSTELL.STAGE.DAIRY.INPUT.ANIMALS_ENTERING_STAGE.CONTINUOUS_GROWING.TOOLTIP`
              : `SUSTELL.STAGE.DAIRY.INPUT.ANIMALS_ENTERING_STAGE.TOOLTIP`,
          })}
          required
          type="number"
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.numberAnimals`
          )}
        />
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.distanceTruck`}
          type="number"
          label={intl.formatMessage({
            id: `SUSTELL.STAGE.DAIRY.INPUT.DISTANCE_TRUCK`,
          })}
          adornment={distanceUnit}
          disabled={formType === FormType.View}
          tooltip={intl.formatMessage({
            id: stageType === StageType.ContinuousGrowing
              ? `SUSTELL.STAGE.DAIRY.INPUT.DISTANCE_TRUCK.CONTINUOUS_GROWING.TOOLTIP`
              : `SUSTELL.STAGE.DAIRY.INPUT.DISTANCE_TRUCK.TOOLTIP`,
          })}
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.distanceTruck`
          )}
        />
        <ReactHookDsmInput
          name={`${fieldItemPrefix}.shrinkingRate`}
          label={intl.formatMessage({
            id: 'SUSTELL.STAGE.DAIRY.INPUT.WEIGHT_LOSS',
          })}
          disabled={formType === FormType.View}
          adornment="%"
          type="number"
          tooltip={intl.formatMessage({
            id: `SUSTELL.STAGE.DAIRY.INPUT.WEIGHT_LOSS.TOOLTIP`,
          })}
          placeholder={intl.formatMessage({
            id: `SUSTELL.STAGE.DAIRY.INPUT.WEIGHT_LOSS.PLACEHOLDER`,
          })}
          defaultValue={formContext.getValues(
            `${fieldItemPrefix}.shrinkingRate`
          )}
        />
      </DsmGrid>
    </>
  );
};

export default DairyV2InputPartInternalSource;
